import React, { useRef, useState } from 'react';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';
import RenameColumnDialog from './RenameColumnDialog';

const ColumnHeader = ({ column, itemsCount, totalItems, isLocked, handleRef, isDefaultColumn, onRename, onArchive }) => {
  const opanel = useRef();
  const [showRenameDialog, setShowRenameDialog] = useState(false);

  const handleRename = () => {
    setShowRenameDialog(true);
  };

  const confirmRename = async (newName) => {
    if (newName && newName.trim() !== column?.lead_stage_name) {
      const result = await onRename({ sk: column.sk, pk: column.pk, newName: newName.trim() });
      if (!result?.success) {
        console.error('Failed to rename column');
      }
    }
  };

  const handleArchive = () => {
    if (itemsCount > 0) {
      confirmDialog({
        message: 'This stage contains active leads. Please move the active leads to another stage before archiving.',
        header: 'Cannot Archive Stage',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        rejectClassName: 'd-none',
        accept: () => {},
        style: { width: '450px' },
      });
    } else {
      confirmDialog({
        message: `Are you sure you want to archive "${column?.lead_stage_name}"? This will hide it from the board.`,
        header: 'Confirm Archive',
        icon: 'pi pi-info-circle',
        acceptLabel: 'Yes, Archive',
        rejectLabel: 'Cancel',
        acceptClassName: 'p-button-danger',
        style: { width: '450px' },
        rejectClassName: 'outline',
        accept: async () => {
          const result = await onArchive(column.sk, column.pk);
          if (!result?.success) {
            console.error('Failed to archive column');
          }
        },
        reject: () => {},
      });
    }
  };

  const menuItems = [
    {
      label: 'Rename',
      icon: 'pi pi-pencil',
      command: handleRename,
      disabled: isDefaultColumn || isLocked,
    },
    {
      label: 'Archive',
      icon: 'pi pi-trash',
      command: handleArchive,
      disabled: isDefaultColumn || isLocked,
    },
  ];

  return (
    <>
      <div ref={handleRef} className="column-header p-3" style={{ cursor: isLocked ? 'not-allowed' : 'grab' }}>
        <div className="column-header-content">
          <div className="column-title-section">
            <h3 className="column-title mb-0">
              <span>{column.lead_stage_name}</span>
              {isLocked && (
                <span className="lock-icon d-flex align-items-center" title="This stage position is locked">
                  <i className="pi pi-lock" />
                </span>
              )}
            </h3>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="column-badge">{totalItems}</span>

            <div className="pointer">
              <div
                className="d-flex border border-1 rounded justify-content-center p-2 task-lane-header-options pointer"
                onClick={(e) => opanel?.current?.toggle(e)}
              >
                <i className="pi pi-ellipsis-v d-flex align-items-center" />
              </div>
            </div>
          </div>
        </div>

        <Menu model={menuItems} popup ref={opanel} id="popup_menu" />
      </div>

      {showRenameDialog && (
        <RenameColumnDialog
          visible
          onHide={() => setShowRenameDialog(false)}
          onSubmit={confirmRename}
          currentName={column?.lead_stage_name}
        />
      )}
    </>
  );
};

export default React.memo(ColumnHeader);
